import React from 'react'
import { connect } from 'react-redux'
import styles from './FollowButton.scss'
import { Button } from 'common/Button'
import * as followActions from 'lib/api/usersFollowed'
import { FormattedMessage as T } from 'react-intl'

export const FollowButton = ({ onChange, isFollowing }) => (
  <div style={{ display: 'inline-block' }}>
    {!isFollowing && <Button type='default' className={styles.FollowButton} onClick={() => onChange(true)}>
      <T id='FollowButton.follow' defaultMessage='Follow' />
    </Button>}
    {isFollowing && <Button type='default' className={styles.FollowButton} onClick={() => onChange(false)}>
      <span className={styles.normal}>
        <T id='FollowButton.following' defaultMessage='Following' />
      </span>
      <span className={styles.hover}>
        <T id='FollowButton.unfollow' defaultMessage='Unfollow' />
      </span>
    </Button>}
  </div>
)

const mapStateToProps = (state, ownProps) => ({
  currentUser: state.currentUser.id,
  isFollowing: state.usersFollowed.get(ownProps.targetUserId, false)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (follow) => (
    follow
      ? dispatch(followActions.followUser(ownProps.targetUserId))
      : dispatch(followActions.unfollowUser(ownProps.targetUserId))
  )
})

export const FollowButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FollowButton)
